import {
  MasonryEngineActionHandler,
  MasonryEngineNodeAction,
} from '@leagueplatform/masonry-engine';
import { MasonryDriverAction } from '@leagueplatform/masonry-renderers';
import {
  Dependent,
  legacyOrderNewCardStore,
} from '@leagueplatform/legacy-order-new-card';

type BenefitsLegacyOrderNewCardAction = MasonryEngineNodeAction<
  'legacyOrderNewCard',
  {
    benefitId: string;
    dependents?: Dependent[];
    vendorId: string;
    title: string;
    benefitSource: string;
    benefitType: string;
  }
>;

type BenefitsLegacyOrderNewCardActionHandler = MasonryEngineActionHandler<
  BenefitsLegacyOrderNewCardAction,
  MasonryDriverAction
>;

/**
 * Action handler for the legacyOrderNewCard action.
 * Renders the LegacyOrderNewCard modal with the provided benefitId using context-aware rendering.
 */
export const legacyOrderNewCardActionHandler: BenefitsLegacyOrderNewCardActionHandler =
  async (action) => {
    const {
      benefitId,
      dependents,
      vendorId,
      title,
      benefitSource,
      benefitType,
    } = action.payload;

    const { setOrderNewCardInstance, reset } =
      legacyOrderNewCardStore.getState();

    const elementToFocusOnClose = (action.event?.target ||
      document.activeElement) as HTMLElement | null;

    setOrderNewCardInstance({
      benefitId,
      benefitSource,
      benefitType,
      dependents: dependents || [],
      elementToFocusOnClose,
      isOpen: true,
      onComplete: () => {
        reset();
      },
      title,
      vendorId,
    });
  };
